import api from '../../../../api/api'
import url from '../../../../api/env'
import Utils from '../../../../utils/Utils'

const getProductCsv = async (id, sort_type = 'desc') =>
  api
    .get(`${url.stage.productsCsvOptions}/?store_chain_id=${id}&sort_type=${sort_type}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getPresentationCsv = async (id, sort_type = 'desc') =>
  api
    .get(`${url.stage.presentationsCsvOptions}/?store_chain_id=${id}&sort_type=${sort_type}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getDiscountsCsv = async (id, sort_type = 'desc') =>
  api
    .get(`${url.stage.discountsCsvOptions}/?company_id=${id}&sort_type=${sort_type}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getSkuCsv = async (id, sort_type = 'desc') =>
  api
    .get(`${url.stage.presentationsSkusCsvOptions}/?store_chain_id=${id}&sort_type=${sort_type}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getCombosCsv = async (id, sort_type = 'desc') =>
  api
    .get(`${url.stage.presentationsCombosCsvOptions}/?company_id=${id}&sort_type=${sort_type}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const getPresentationDiscountCsv = async (id, sort_type = 'desc') =>
  api
    .get(`${url.stage.presentationsDiscountsCsvOptions}/?company_id=${id}&sort_type=${sort_type}&paginate=0`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getProductCsv,
  getPresentationCsv,
  getDiscountsCsv,
  getSkuCsv,
  getCombosCsv,
  getPresentationDiscountCsv
}
